import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { useSLUGName } from '../../hooks/useHistory';
import { RESTClient } from '../client';

export type ScheduleCheckResponse = {
  has_schedules: boolean;
  schedule_count: number;
};

const CHECK_SCHEDULES = 'CHECK_SCHEDULES';

const makeQueryScheduleCheck = async (params: Record<string, any>) => {
  const { data } = await RESTClient.get<ScheduleCheckResponse>('/schedules/check', {
    params,
  });

  return data;
};

export const useQueryScheduleCheck = () => {
  const organization = useSLUGName();
  const params = useMemo(
    () => ({
      ...(organization ? { organization } : {}),
    }),
    [organization],
  );

  const processor = useCallback(() => makeQueryScheduleCheck(params), [params]);
  const {
    data,
    isLoading: loading,
    refetch,
  } = useQuery([CHECK_SCHEDULES, params], processor, {
    enabled: !!organization,
  });

  return {
    hasSchedules: data?.has_schedules ?? false,
    scheduleCount: data?.schedule_count ?? 0,
    loading,
    refetch,
  };
};
